import React from 'react';
import { m } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { scrollToId } from '../../utils/scroll';
import { transformationRows, transformationFooterStats } from '../../data/transformation';
export function Transformation() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-217" data-mp="2ffdpkivf2uhn">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-218" data-mp="2bfbx90bkndf1">
        <SectionTag icon="⚡" data-id="element-219" data-mp="2bh6g893a8vgh">La transformación</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-ink sm:text-4xl" data-id="element-220" data-mp="26nbpilp9fg7w">
          Tus preparaciones no deberían ser así...
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-221" data-mp="2z567da4ianvl">
          Un domingo por la noche, buscando ejercicios sueltos en Pinterest que no sabes si van a funcionar
          el martes con tus alumnos. Dudando si está bien alineado con LOMLOE. Preguntándote cómo adaptar
          para el alumno con dificultad.
        </p>

        <div className="mt-6 rounded-2xl border border-flash/20 bg-flash/5 p-5 text-left sm:p-6" data-id="element-222" data-mp="1a6rcjuod60xv">
          <p className="font-heading text-sm font-bold uppercase tracking-wide text-flash" data-id="element-223" data-mp="wfct5mqjnxqa">
            Recupera tus domingos
          </p>
          <p className="mt-2 text-sm leading-relaxed text-muted sm:text-base" data-id="element-224" data-mp="mhorsdyfnrz5">
            <span className="font-semibold text-ink" data-id="element-225" data-mp="mk1fz8usaykn">El coste real:</span> Planificar manualmente te quita
            de <span className="rounded-sm bg-yellow px-1 font-semibold text-navy" data-id="element-226" data-mp="dh09h720b5gg">4 a 7 horas por semana</span>.
            Es el equivalente a más de un mes entero de trabajo al año quemado en búsquedas, dudas sobre
            LOMLOE y preparaciones que no funcionan.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-227" data-mp="2bwmp3od7oqw0">
        <div className="space-y-4" data-id="element-228" data-mp="2bw3bgjulgons">
          {transformationRows.map((row, i) => <m.div key={row.title} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="rounded-2xl border border-slate-200 bg-bg-secondary p-5 sm:p-6" data-id="element-229" data-mp="3kucthrhcifzt" data-mpi={i}>
              <p className="mb-3 text-xs font-bold uppercase tracking-wider text-muted" data-id="element-230" data-mp="7enhk1sdulet">
                {row.title} · {row.n}
              </p>
              <div className="grid gap-4 sm:grid-cols-2" data-id="element-231" data-mp="3ed1txesggmr">
                <div className="flex items-start gap-3" data-id="element-232" data-mp="3urhkc4m4yzmy">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-danger/10" data-id="element-233" data-mp="3upwp0crzzco1">
                    <XIcon size={14} className="text-danger" data-id="element-234" data-mp="3pqtq7a2m22oi" />
                  </div>
                  <div data-id="element-235" data-mp="r4qyy2c8d5o7">
                    <p className="text-xs font-bold uppercase tracking-wide text-danger" data-id="element-236" data-mp="mc7lr6hggcjx">Antes</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-237" data-mp="tnc60dr2513q">{row.before}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-238" data-mp="yn8a0czr8sja">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-success/10" data-id="element-239" data-mp="13l9u918x2xwc">
                    <CheckIcon size={14} className="text-success" data-id="element-240" data-mp="17n3rezjwljrr" />
                  </div>
                  <div data-id="element-241" data-mp="1cmgffnmigwvx">
                    <p className="text-xs font-bold uppercase tracking-wide text-success" data-id="element-242" data-mp="1cl59pi9i9f26">Ahora</p>
                    <p className="mt-1 text-sm leading-relaxed text-ink" data-id="element-243" data-mp="1hjqbvn8bi8t9">{row.after}</p>
                  </div>
                </div>
              </div>
            </m.div>)}
        </div>

        <div className="mt-8 flex justify-center" data-id="element-244" data-mp="1r9t4vnffvmrl">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-245" data-mp="1vcfyntvo7hrf">Quiero dejar de improvisar</PrimaryButton>
        </div>

        <div className="mt-8" data-id="element-246" data-mp="20azmy0xql5my">
          <ScrollHintTable minWidth="480px" data-id="element-247" data-mp="20cam1ng8lp7q">
            <div className="grid grid-cols-3 divide-x divide-slate-200 bg-bg-secondary" data-id="element-248" data-mp="1mosezro6y6c8">
              {transformationFooterStats.map(stat => <div key={stat.label} className="flex flex-col items-center gap-1 px-3 py-6 text-center" data-id="element-249" data-mp="1imfd5eckeskq">
                  <span className="font-heading text-xl font-bold text-flash sm:text-2xl" data-id="element-250" data-mp="1we3nbc3976z2">{stat.value}</span>
                  <span className="text-xs text-muted sm:text-sm" data-id="element-251" data-mp="1rgah4j1yacys">{stat.label}</span>
                </div>)}
            </div>
          </ScrollHintTable>
        </div>
      </div>
    </section>;
}